module.exports = __webpack_public_path__ + "static/media/ctc_event_0.6082cf5a.jpeg";